import React, { ReactNode } from "react";
import Grid from "@mui/material/Grid";
import ChipStyles from "../Utilities/Styles/ChipStyles";
import EditIcon from '@mui/icons-material/Edit';


interface IFilterChipDisplayProps {
    text: ReactNode
    selectable?: boolean
    onClick?: () => void
}

export default function FilterChipDisplay({ text, selectable, onClick }: IFilterChipDisplayProps) {
    return (
        <Grid>
            <Grid
                container
                sx={
                    selectable
                        ? ChipStyles.selectableChipContainer
                        : ChipStyles.chipContainer}
                alignItems="center">
                <div onClick={selectable ? onClick : undefined}>
                    <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                        spacing={1}
                        sx={ChipStyles.chipText}>
                        <Grid>
                            {
                                text
                            }
                        </Grid>
                        {
                            selectable &&
                            <Grid>
                                <EditIcon
                                    color="primary"
                                    sx={{
                                        height: 15,
                                        paddingLeft: 1,
                                        marginTop: '5px'
                                    }} />
                            </Grid>
                        }
                    </Grid>
                </div>
            </Grid>
        </Grid>
    )
}